export default __webpack_public_path__ + "static/media/subLogo.0bf26d86.svg";